export default __webpack_public_path__ + "static/media/bg_login.9e0f73a5.png";